import React, { useMemo } from 'react'
import Header from 'pobble-components/dist/pobble-header'
import { useLocation } from 'react-router-dom'

const LessonHeader = () => {
  const { pathname } = useLocation()

  const isPreview = useMemo(
    () => {
      return (
        pathname.startsWith('/preview/') || pathname.startsWith('/teachers/')
      )
    },
    [pathname]
  )

  const isCalendar = useMemo(
    () => {
      return pathname.endsWith('/calendar')
    },
    [pathname]
  )

  const style = useMemo(
    () => {
      const calendar = isCalendar
        ? { position: 'sticky', top: 0, zIndex: 200 }
        : {}
      return { display: isPreview ? 'none' : 'flex', ...calendar }
    },
    [isPreview, isCalendar]
  )

  return (
    <Header
      activePage={pathname.startsWith('/works/') ? 'pobble-app' : 'prompts'}
      style={style}
      parent
    />
  )
}

export default LessonHeader
